import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SearchBar } from 'react-weui'
import * as liveroomSetLecAct from '../../actions/liveroomSettingLecture'


class LectureSearch extends React.Component {
    componentDidMount () {
        const $form = document.querySelector('.weui-search-bar form')
        if ($form) {
            $form.setAttribute('action', '.')
        }
    }
    onSubmit (type, liveroomId) {
        this.props.setIsPending(true)
        document.querySelector('.weui-search-bar input').blur()
        if (type === 'lecture') {
            // this.props.setIsScrollStop(false)
            // this.props.setIsScrollKill(false)
            this.props.setlecturesOffset(0)
            this.props.fetchLectures(liveroomId, {
                keyword: encodeURIComponent(this.props.lectureKeyword),
                offset: 0,
                isSearch: true,
                limit: 1000,
            })
        } else {
            this.props.fetchChannels(liveroomId, {
                keyword: encodeURIComponent(this.props.channelKeyword),
                offset: 0,
                isSearch: true,
            })
        }
    }
    onCancel () {
        this.props.setIsPending(true)
        this.props.setIsSearchEmpty(false)
        if (this.props.type === 'lecture') {
            this.props.setLectureKeyword('')
            this.props.fetchLectures(this.props.liveroomId)
        } else {
            this.props.setChannelKeyword('')
            this.props.fetchChannels(this.props.liveroomId)
        }
    }
    onChangeKeyword (text) {
        if (this.props.type === 'lecture') {
            this.props.setLectureKeyword(text)
        } else {
            this.props.setChannelKeyword(text)
        }
    }
    render() {
        const { type, liveroomId, lectures, channels, isLecturesEmpty, isChannelsEmpty } = this.props
        if (lectures && type === 'lecture' && lectures.length === 0 && isLecturesEmpty) return null
        if (channels && type === 'channel' && channels.length === 0 && isChannelsEmpty) return null
        return (
            <SearchBar
                onChange={text => this.onChangeKeyword(text)}
                placeholder="搜索"
                lang={{
                    cancel: '取消'
                }}
                onCancel={e => this.onCancel()}
                onSubmit={e => this.onSubmit(type, liveroomId)}
            />
        )
    }
}


export default connect(state => ({
    lectures: state.liveroomSettingLecture.lectures,
    channels: state.liveroomSettingLecture.channels,
    lectureKeyword: state.liveroomSettingLecture.lectureKeyword,
    channelKeyword: state.liveroomSettingLecture.channelKeyword,
    isChannelsEmpty: state.liveroomSettingLecture.isChannelsEmpty,
    isLecturesEmpty: state.liveroomSettingLecture.isLecturesEmpty,
}), dispatch => bindActionCreators({ ...liveroomSetLecAct }, dispatch))(LectureSearch)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LectureSearch.js